<template>
	<div>
		<footer>
			<div class="footer wh">
				<div class="footer-top rel">
					<div class="l">
						<div class="hotline">
							<div>
								<p class="c1">全国服务热线</p>
								<p class="tel">400-631-1169</p>
							</div>
							
						</div>
						<div class="edit-box msg c1">
							<p><img src="@/assets/images/erweima.png" /></p>
							<p>官方公众号</p>
						</div>
						<div class="qr-box flex">
							<div class="qr">
								<div class="imgbox">
									<img src="" alt="">
								</div>
								<p class="c1"></p>
							</div>
						</div>
					</div>
					<div class="r">
						<ul class="flex ai-start">
							<li v-for="item in configList">
								<a class="item" href="javascript:void(0)">{{item.categoryName}}</a>
								
								<a class="item" href="javascript:void(0)" v-for="items in item.children" @click="goTwo(items)">{{items.categoryName}}</a>
								
		
							</li>
		
							<!-- <li>
								<a class="item" href="03集团动态 01 新闻列表.html">集团动态</a>
		
								<a class="item" href="03集团动态 01 新闻列表.html">政策解读</a>
								<a class="item" href="03集团动态 01 新闻列表.html">新闻中心</a>
		
							</li>
							<li>
								<a class="item" href="04业务范围 01业务列表.html">业务范围</a>
								<a class="item" href="04业务范围 01业务列表.html">水利市政</a>
								<a class="item" href="04业务范围 01业务列表.html">雷达天线</a>
								<a class="item" href="04业务范围 01业务列表.html">新能源</a>
								<a class="item" href="04业务范围 01业务列表.html">共享智造</a>
		
							</li>
							<li>
								<a class="item" href="06项目案例 01案例列表.html">项目案例</a>
								<a class="item" href="06项目案例 01案例列表.html">案例分类</a>
								<a class="item" href="06项目案例 01案例列表.html">案例分类</a>
								<a class="item" href="06项目案例 01案例列表.html">案例分类</a>
								<a class="item" href="006项目案例 01案例列表.html">案例分类</a>
		
							</li>
							<li>
								<a class="item" href="07社会责任 01党建引领.html">社会责任</a>
								<a class="item" href="07社会责任 01党建引领.html">党建引领</a>
								<a class="item" href="07社会责任 02责任担当.html">责任担当</a>
		
							</li>
							<li>
								<a class="item" href="08联系我们 02联系我们.html">联系我们</a>
								<a class="item" href="08联系我们 01人才招聘.html">人才招聘</a>
								<a class="item" href="08联系我们 02联系我们.html">联系我们</a>
		
							</li> -->
						</ul>
					</div>
				</div>
		
				<div class="friend-link">
		
		
		
				</div>
		
				<div class="footer-btm">
					<div class="copyright1">
		
		
						<p>地址：河北省衡水市枣强县裕枣东街187号 Tel:+86-(0)318-8237788 400-636-1169</p>
						<p>Fax:+86-(0)318-8238869 E-mail: hengrun@hengrungroup.com </p>
						<p>Copyright © 恒润集团有限公司 All rights reserved 备案号：<a href="https://beian.miit.gov.cn/"
								target="_blank">冀ICP备16028546号-2</a></p>
		
					</div>
				</div>
			</div>
		</footer>
	</div>

</template>
<script>
	import {
		categorysortPage,
	} from '@/api/reqFetch.js'
	export default {
		data() {
			return {
				configList:[]
			}
		},
		mounted() {
			this.getCategorysortPage()
		},
		methods: {
			go(url) {
				if (this.$route.fullPath != url) {
					this.$router.push(url)
					this.$router.go(0)
				}
			},
			getCategorysortPage() {
				categorysortPage({
					pos: 'top'
				}).then(res => {
					res.data.map(item => {
						item.children.sort((a, b) => a.orderNum - b.orderNum);
					})
					this.configList = res.data
				});
			},
			goTwo(item) {
				let url='/'+item.url+'?type=' + item.categoryCode+'&title='+item.categoryName
				this.go(url)
			}
		}

	}
</script>
<style scoped>


</style>